"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.search.placeholder': '搜索问题...',
};
